export const adminList = Object.freeze({
  TENANT: "tenant",
  CLIENT: "client",
});
